<template>
    <template v-if="entriesFound">
        <div v-if="configurations" class="configuration__list">
            <template v-for="(configuration, index) in getConfigurationArray()" :key="configuration">
                <div :class="['configuration__list--entry', { 'list--disabled': (configuration.ordered && opacityHandler) }]" :data-test="index" v-if="index+1 <= visibleEntries && configuration">
                    <template v-if="getConfigurationType(configuration) == 'user_configuration'">
                        <div class="hover__entry">
                            <div class="hover__entry--buttons" :class="{'ordered': configuration.ordered}">
                                <div @click="openConfigurator(configuration);">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1.5" y="1.5" width="17" height="17" stroke="black"/>
                                        <path d="M9 4.5H15.5V10.5" stroke="black"/>
                                        <path d="M15.5 4.5L8.25 11.75" stroke="black"/>
                                    </svg>
                                    <span>{{$t('open')}}</span>
                                </div>
                                <div @click="downloadConfiguration(configuration.id);">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.5 14V19.5H19.5V14" stroke="black"/>
                                        <path d="M10 0V13" stroke="black"/>
                                        <path d="M15 9L10 13L5 9" stroke="black"/>
                                    </svg>
                                    <span>{{$t('download')}}</span>
                                </div>
                                <div v-if="false" @click="shareConfiguration(configuration.id);">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7 6.5H3C2.72386 6.5 2.5 6.72386 2.5 7V18C2.5 18.2761 2.72386 18.5 3 18.5H17C17.2761 18.5 17.5 18.2761 17.5 18V7C17.5 6.72386 17.2761 6.5 17 6.5H13" stroke="black"/>
                                        <path d="M6.49951 4L9.99951 0.5L13.4995 4" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M10 0.5L10 9.5" stroke="black" stroke-linecap="round"/>
                                    </svg>
                                    <input type="hidden" :id="configuration.id" :value="configuration.id" />
                                    <span>{{$t('share_config')}}</span>
                                </div>
                                <div @click="createNewConfiguration(configuration.id);">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1.5" y="1.5" width="13" height="13" stroke="black"/>
                                        <path d="M16 6.5H18.5V18.5H6.5V16" stroke="black"/>
                                    </svg>
                                    <input type="hidden" :id="configuration.id" :value="configuration.id" />
                                    <span>{{$t('duplicate')}}</span>
                                </div>
                                <div v-if="!configuration.ordered" @click="deleteConfiguration(configuration.id);">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.5 3.5H16.5V19.5H3.5V3.5Z" stroke="black"/>
                                        <path d="M6.5 2.5C6.5 1.39543 7.39543 0.5 8.5 0.5H11.5C12.6046 0.5 13.5 1.39543 13.5 2.5V3.5H6.5V2.5Z" stroke="black"/>
                                        <path d="M1 3.5H19" stroke="black"/>
                                        <path d="M7.5 8V15" stroke="black"/>
                                        <path d="M12.5 8V15" stroke="black"/>
                                    </svg>
                                    <span>{{$t('delete')}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="configuration__list--flex" @click="openConfigurator(configuration);">
                            <touch-flex :configuration="configuration"></touch-flex>
                        </div>
                        <div :class="['configuration__list--meta']">
                            <h3>{{$t('products.touch_flex.'+configuration.sku)}}</h3>
                            <p class="description">{{configuration.description}}</p>
                            <h4>
                                <span>{{$t('')}} {{configuration.id}}</span>
                                <span class="copy" @click="copyConfigurationId(configuration.id);">
                                    <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 1.5C1 1.22386 1.22386 1 1.5 1H14.5C14.7761 1 15 1.22386 15 1.5V14.5C15 14.7761 14.7761 15 14.5 15H1.5C1.22386 15 1 14.7761 1 14.5V1.5ZM2 14V2H14V14H2Z" fill="black"/>
                                        <path d="M16 6C15.7239 6 15.5 6.22386 15.5 6.5C15.5 6.77614 15.7239 7 16 7H18V18H7V16C7 15.7239 6.77614 15.5 6.5 15.5C6.22386 15.5 6 15.7239 6 16V18.4C6 18.7314 6.26863 19 6.6 19H18.4C18.7314 19 19 18.7314 19 18.4V6.6C19 6.26863 18.7314 6 18.4 6H16Z" fill="black"/>
                                    </svg>
                                </span>
                            </h4>
                        </div>
                    </template>
                    <template v-else>
                        <div class="configuration__list--flex" style="cursor: copy;" @click="openNewFlexInterface(configuration)">
                            <touch-flex :configuration="configuration"></touch-flex>
                        </div>
                        <div v-if="getConfigurationType(configuration) == 'loxone_configuration'" class="configuration__list--meta">
                            <h3>{{configuration.description}}</h3>
                        </div>
                    </template>
                </div>
            </template>
        </div>
        <div class="button__more--wrapper" v-if="configurations.length > visibleEntries">
            <a @click="visibleEntries = visibleEntries+9999;" class="btn btn--ghost">{{$t('show_all_info')}}</a>
        </div>
    </template>
    <template v-else>
        <div class="no__serach--results">
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="40" fill="#F5F5F5"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M24.9163 23.5336C26.1196 22.0293 26.8391 20.1212 26.8391 18.0451C26.8391 13.1888 22.9023 9.25195 18.046 9.25195C13.1897 9.25195 9.25293 13.1888 9.25293 18.0451C9.25293 22.9014 13.1897 26.8382 18.046 26.8382C20.1222 26.8382 22.0303 26.1186 23.5346 24.9153L29.0793 30.46C29.4609 30.8416 30.0795 30.8416 30.461 30.46C30.8426 30.0785 30.8426 29.4599 30.461 29.0783L24.9163 23.5336ZM18.046 24.8841C14.2689 24.8841 11.207 21.8222 11.207 18.0451C11.207 14.2679 14.2689 11.206 18.046 11.206C21.8232 11.206 24.8851 14.2679 24.8851 18.0451C24.8851 21.8222 21.8232 24.8841 18.046 24.8841Z" fill="black"/>
            </svg>
            <div>{{$t('no_search_results')}}</div>
        </div>
    </template>
</template>

<script>
    import axios from 'axios';
    import 'vue3-carousel/dist/carousel.css';
    import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel';
    import TouchFlex from '../components/TouchFlex.vue';
import Touch_Flex from '../views/Touch_Flex.vue';
import { jsxIdentifier } from '@babel/types';
    export default {
        name: 'ConfigurationList',
        data() {
            return {
                entriesFound: true,
            }
        },
        components:{
            Carousel,
            Slide,
            Pagination,
            Navigation,
            TouchFlex,
                Touch_Flex,
        },
        props: {
            configurations: {
                type: Object,
                required: true,
            },
            visibleEntries: {
                type: Number,
                required: true,
            },
            opacityHandler: {},
        },
        watch: {
            '$store.state.flexSearchTerm': function() {
                this.getConfigurationArray();
            }
        },
        methods: {
            //createNewConfiguration(configuration.id)
            openNewFlexInterface(data){
                this.$store.state.newTouchFlexInterfaceVisible = true;
                
                this.$store.state.newTouchFlexConfiguration = JSON.parse(JSON.stringify(data));
            },
            getConfigurationArray() {
                let configurations = [];
                for (const [key, value] of Object.entries(this.configurations)) {
                    if(!value.hidden || value.hidden == false) {
                        configurations[key]  = value;
                    }
                }

                if(this.configurations.length > 0 && configurations.length == 0) {
                    this.entriesFound = false;
                } else {
                    this.entriesFound = true;
                }

                return configurations;
            },
            getConfigurationType(configuration) {
                
                if(configuration.id) {
                    if(configuration.id.substring(0, 4) == 'temp') {
                        return "template";
                    } else if(configuration.contact_id == 'b1976cbe-c778-4521-995a-c538b45a0956') {
                        return "loxone_configuration";
                    } else {
                        return "user_configuration";
                    }
                } else {
                    return "template";
                }
            },
            openConfigurator(configuration) {
                this.$router.push({
                    path: '/configurator/' + configuration.id + '/edit/' + configuration.hash
                });
            },
            downloadConfiguration(configuration_id) {
                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://configurator.loxone.com/api/getTouchFlexConfiguration/' + configuration_id,
                })
                .then(resp => {
                    var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(resp.data));
                    var downloadAnchorNode = document.createElement('a');
                    downloadAnchorNode.setAttribute("href",     dataStr);
                    downloadAnchorNode.setAttribute("download", configuration_id + ".json");
                    document.body.appendChild(downloadAnchorNode); // required for firefox
                    downloadAnchorNode.click();
                    downloadAnchorNode.remove();
                });

            },
            copyConfigurationId(configuration_id) {

                let testingCodeToCopy = document.querySelector('#'+configuration_id)
                testingCodeToCopy.setAttribute('type', 'text');
                testingCodeToCopy.select();

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                } catch (err) {
                }

                /* unselect the range */
                testingCodeToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            },
            deleteConfiguration(configuration_id) {
                var configurationData = new FormData();
                configurationData.append('configuration_id', configuration_id);
                
                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    data: configurationData,
                    url: 'https://configurator.loxone.com/api/deleteConfiguration',
                })
                .then(resp => {
                    if(resp.data.success) {
                        for (const [key, value] of Object.entries(this.configurations)) {
                            if(value.id == configuration_id) {
                                delete this.configurations[key];
                            }
                        }
                    }
                });
            },
            createNewConfiguration(configuration_id) {
                var configurationData = new FormData();
                configurationData.append('configuration_id', configuration_id);

                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    data: configurationData,
                    url: 'https://configurator.loxone.com/api/createNewConfiguration',
                })
                .then(resp => {
                    if (resp.data) {
                        this.$router.push({
                            path: '/configurator/' + resp.data.configuration_id + '/edit/' + resp.data.hash
                        });
                    }

                });
            }
        },
        created() {
        },
    }
</script>

<style lang="scss">

    .no__serach--results{
        padding: 100px 0 30px 0;
        text-align: center;
        color: #8F8F8F;
        font-size: 16px;
    }

    .button__more--wrapper{
        text-align: center;
        margin-top: 50px;
    }

    .shark-anthracite .button__more--wrapper .btn--ghost{
        border-color: #FFFFFF;
        color: #FFFFFF;

        &:hover{
            color: #000000;
            background: #FFFFFF;
        }
    }

    .configuration__list{
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        text-align: center;
        grid-row-gap: 40px;

        .touch__flex{
            transform-origin: left top;
            transform: scale(0.3);

            .orientation__light,
            .display__info,
            .status__led{
                display: none;

            }
        }
    }

    textarea{
        outline: none;
        border-radius: 1px;
        background-color: #EDEDED;
        border: 1px solid #D9D9D9;
        text-align: center;
        line-height: 1.2em;
        font-size: 14px;
        width: 100%;
        font-family: 'averta-regular', Arial, Helvetica, sans-serif;
        box-sizing: border-box;
        padding: 5px;
        resize: none;
    }
    .carousel__slide{
        padding: 0px 40px;
        align-items: flex-start !important;
    }

    .carousel__viewport{
        overflow: visible;
        overflow-x: clip;
    }

    .carousel__pagination{
        margin-top: 10px;

        .carousel__pagination-button{
            background-color: #D2D2D2;
        }
        .carousel__pagination-button--active{
            background-color: #575C61;
        }
    }

    .carousel__prev,
    .carousel__next{
        background-color: transparent;
        width: 40px;
        height: 40px;

        svg{
            width: 40px;
            height: 40px;

            path{
                fill: black;
            }
        }
    }

    .carousel__pagination-item{
        button{
            width: 12px;
            height: 12px;
            border-radius: 50%;
        }
    }
    .configuration__list{

        .configuration__list--entry{
            .touch__flex{
                margin: 0 auto;
            }
        }
    }

    @media screen and (max-width: 1000px) {
        .configuration__list{
            grid-template-columns: repeat(1, 1fr);
        }
    }
</style>

<style lang="scss">
    .configuration__list{
        .configuration__list--entry{
            &.list--disabled{
                .touch__flex,
                .configuration__list--meta{
                    opacity: 0.4;
                }
            }
        }

    }
</style>

<style lang="scss" scoped>
    .configuration__list{        
        .configuration__list--entry{
            position: relative;

            .configuration__list--flex{
                cursor: pointer;
                height: 270px;
                width: 270px;
                margin: 0 auto;

                > div{
                    height: 270px;
                }
            }

            .configuration__list--meta{
                max-width: 270px;
                margin: 0 auto;
            }


            &:hover .hover__entry{
                display: grid;
            }

            .hover__entry{
                padding-bottom: 8px;
                display: none;
                position: absolute;
                top: -64px;
                left: -45px;
                right: -45px;
                height: 67px;
                z-index: 10;

                .hover__entry--buttons{
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    border-radius: 4px;
                    background-color: #FFFFFF;
                    box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.5);

                    &.ordered{
                        grid-template-columns: repeat(3, 1fr);
                    }

                    div {
                        cursor: pointer;
                        padding: 12px 12px 3px 12px;
                        display: grid;
                        grid-template-rows: 20px auto;
                        grid-row-gap: 8px;
                        text-align: center;
                        font-size: 12px;
                        line-height: 15px;

                        svg{
                            margin: 0 auto;
                        }
                    }
                }
            }

        }

        h3{
            font-size: 16px;
            line-height: 1.5em;
            margin: 20px 0 0 0 ;
            font-weight: normal;
            font-family: 'averta-extrabold', Arial, Helvetica, sans-serif;
        }

        h4{
            font-size: 12px;
            margin: 10px 0 0 0;
            font-weight: normal;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        p.description{
            margin-top: 0px;
            margin-bottom: 10px;
            font-size: 12px;
            font-style: italic;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4; /* number of lines to show */
                    line-clamp: 4; 
            -webkit-box-orient: vertical;
            word-break: break-all;
        }

        .copy{
            margin-left: 4px;

            &:active{
                path {
                    fill: #69C350;
                }
            }
        }
    }
</style>